/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    // unitBase,
    rowSpacing,
    fontSizeDesktop,
    // fontSize,
    enterpriseCSS,
} from './variables';

export const DesktopTrackOrderStyle = (typography, palette) => ({
    trackOrderHeader: {
        width: '100%',
        textAlign: 'center',
        borderBottom: '1px solid #000',
        lineHeight: '0.1em',
        margin: 'auto',
        maxWidth: '1170px',
        '& span': {
            background: palette.white,
            padding: '0 10px',
            fontSize: '20px !important',
        },
    },
    DesktopTrackOrderStyle: {
        maxWidth: palette.myAccount.container.maxWidth.upLarge,
        margin: 'auto',
        // maxWidth: '1200px',
        display: 'flex',
        marginBottom: rowSpacing * 5, // 60px

        '& .deliveryHouseContainer': {
            backgroundColor: palette.myAccount.blockBorderRight,
            color: palette.black,
            width: rowSpacing * 16, // 192px
            minHeight: '313px',
            fontFamily: 'Halvetic',
            marginTop: rowSpacing * 2,
            display: 'inline-block',
            float: 'left',
            textAlign: 'center',
            '& span': {
                display: 'block',
                lineHeight: '19px',
                letterSpacing: '0.35px',
            },
            '& .truckIcon': {
                width: '36px',
                height: '26px',
                marginTop: rowSpacing * 3,
            },
            '& .deliveryText': {
                fontSize: '16px',
                paddingTop: '13px',
                fontWeight: 'Bold',
                textTransform: 'uppercase',
            },
            '& .line': {
                width: rowSpacing * 12, // 144px
                borderBottom: '1px solid',
                display: 'block',
                margin: '0 auto',
                marginTop: rowSpacing * 2,
            },
            '& .hosueContainer': {
                paddingTop: rowSpacing * 2,
                fontSize: '14px',
                '& div': {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                },
                '& .houseIcon': {
                    width: '28px',
                    height: '24px',
                    display: 'block',
                },
            },
            '& .bulidingContainer': {
                paddingTop: rowSpacing * 4, // 48px
                fontSize: '14px',
                '& div': {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                },
                '& .bulidingIcon': {
                    width: '23px',
                    height: '26px',
                    display: 'block',
                },
            },
            '& .leftIconMargin': {
                marginLeft: '14px',
            },
        },

        '& .OR-dividerWrapper': {
            display: 'flex',
            minHeight: '344px',
            float: 'left',
            marginTop: '24px',
            verticalAlign: 'middle',
            alignItems: 'center',
            margin: `0 ${rowSpacing * 4}px`, // 0 48px
            '& .OR-divider': {
                color: palette.white,
                display: 'flex',
                backgroundColor: palette.myAccount.contentGridBorder,
                borderRadius: '50%',
                width: '50px',
                height: '45px',
                fontSize: '16px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },

        '& .signInContainer, & .trackOrderContainer': {
            backgroundColor: palette.white,
            width: rowSpacing * 38, // 432px
            minHeight: rowSpacing * 30, // 360px
            fontFamily: 'Halvetic',
            marginTop: rowSpacing * 2, // 24px
            display: 'block',
            textAlign: 'center',
            margin: '0 auto',
            marginLeft: rowSpacing * 6, // 72px
            border: `1px solid ${palette.myAccount.blockBorderRight}`,
            float: 'left',
            padding: rowSpacing * 2,

            '& .header': {
                fontSize: fontSizeDesktop.large,
                marginTop: rowSpacing * 2,
                fontWeight: 'bold',
                textTransform: 'capitalize',
            },
            '& .subHeader': {
                textTransform: 'capitalize',
                fontSize: fontSizeDesktop.large,
                marginTop: rowSpacing * 2,
                fontWeight: 'bold',
                margin: '0 auto',
                color: palette.black,
                whiteSpace: 'pre-line',
                width: '70%',
            },
        },

        '& .signInContainer': {
            '& .signInBtnWrapper': {
                marginTop: rowSpacing * 4,
                '& .signInBtn, & .signInWithoutPasswordBtn': {
                    fontWeight: 700,
                    backgroundColor: palette.colorPrimary,
                    border: `1px solid ${palette.colorPrimary}`,
                    width: '100%',
                    float: 'none',
                },
                '& .signInWithoutPasswordBtn': {
                    backgroundColor: enterpriseCSS.palette.gray1,
                    border: `1px solid ${enterpriseCSS.palette.gray1}`,
                    marginTop: rowSpacing * 2,
                },
            },
            '& .signUpDivider': {
                margin: '0 auto',
                marginTop: rowSpacing * 5,
                '& span': {
                    fontSize: fontSizeDesktop.component,
                    display: 'inline-block',
                    color: palette.myAccount.contentGridBorder,
                    verticalAlign: 'top',
                    width: '120px',
                },
                '& hr': {
                    border: `1px solid ${palette.myAccount.blockBorderRight}`,
                    display: 'inline-block',
                    width: 'calc(50% - 60px)',
                },
                '& hr:nth-of-type(1n)': {
                    float: 'left',
                },
                '& hr:nth-of-type(2n)': {
                    float: 'right',
                },
            },
            '& .socialBtn': {
                margin: '0 auto',
                marginTop: rowSpacing,
                marginBottom: 0,
                display: 'block',
                height: rowSpacing * 3,

                '&:after': {
                    content: '""',
                    float: 'none',
                    clear: 'both',
                },

                '& .loginSocialBtn': {
                    width: rowSpacing * 14,
                    height: rowSpacing * 3,
                    fontWeight: '330',
                    textTransform: 'none',
                    // fontSize: `${fontSizeDesktop.small}px !important`,
                    marginRight: 0,
                    display: 'flex',
                    padding: '0px',
                    justifyContent: 'flex-start',
                    '& span': {
                        textAlign: 'initial',
                    },
                },
                '& .facebookLogin': {
                    backgroundColor: '#4469B0',  // TO DO
                    border: '1px solid #4469B0',
                    color: palette.white,
                    float: 'left',
                    '&:hover': {
                        backgroundColor: '#4469B0', // TO DO
                    },
                },
                '& .googleLogin': {
                    backgroundColor: '#FFF',
                    border: '1px solid #FFF',
                    float: 'right',
                    color: '#000',
                    boxShadow: '0px 1.8px 7px -1px #7c7c70',
                    '&:hover': {
                        backgroundColor: palette.white,
                    },
                    '& img': {
                        marginRight: '10px',
                    },
                },
                '& .socialLoginImg': {
                    width: '20.6px',
                    height: '18.85px',
                    verticalAlign: 'sub',
                    margin: '0 10px',
                },
            },
        },

        '& .trackOrderContainer': {
            marginLeft: 0,
            width: rowSpacing * 31, // 372px

            '& form': {
                marginTop: rowSpacing,
            },

            '& .submitBtn': {
                fontWeight: 700,
                backgroundColor: palette.colorPrimary,
                border: `1px solid ${palette.colorPrimary}`,
                width: '100%',
                float: 'none',
                '&:hover': {
                    backgroundColor: palette.colorPrimary,
                },
            },

            '& .captchaContainer': {
                width: '100%',
                display: 'block',
                position: 'relative',
                minHeight: '74px',
                marginTop: rowSpacing * 2,
                '& #g-recaptcha > div': {
                    width: '100% !important',
                },
            },
        },
    },
});
